import EdgeCommon from "../edgeCommon";

export default class Edge extends EdgeCommon {
  constructor(isChild) {
    super(isChild);
    this.partId = 'center_island_edge';
    this.partName = 'Edge';
    this.dbName = 'Edge Profile';
    this.translateId = "visualizer.kitchen.center_island.center_island_edge";
    // this.isStoneFeature = true;
    this.customClassName = "edge";
  }

  load(dbFeature) {
    return super.load_(dbFeature, new Edge());
  }
}
